import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button, HeaderTitle, Icon, Label } from '@atlas/ui';

export default function SuccessPopup({ id, data }) {
  const { headerTitle, text, title } = data;
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <BasePopup className="success-modal">
      <HeaderTitle className="left border block-big size-xs" title={headerTitle}>
        <div className="header-title__children">
          <button onClick={handleClose} type="button">
            <Icon name="close" />
          </button>
        </div>
      </HeaderTitle>

      <div className="popup__content">
        <Icon className="success-modal__icon" name="success" />
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={handleClose} />
      </div>
    </BasePopup>
  );
}

SuccessPopup.propTypes = {
  data: PropTypes.shape({
    headerTitle: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
